<template>
<div id="pageTable">
    <v-container grid-list-xl fluid v-if="!csRole">
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 md12 sm12>
                    <v-autocomplete outlined dense :disabled="currentRecharge.ID > 0 || roleCustomer" label="Khách hàng" v-model="currentRecharge.UID" :items="customers" item-text="Username" item-value="ID"></v-autocomplete>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <h-currency-input :disabled="currentRecharge.ID > 0" v-model="currentRecharge.Amount" :decimal="0" label="Số tiền" class="input-group--focused"></h-currency-input>
                </v-flex>
                <!-- <v-flex lg12 md12 sm12>
                    <v-select label="Hình thức" :disabled="currentRecharge.ID > 0" v-model="currentRecharge.Method" :items="rechargeMethods" item-text="name" item-value="value"></v-select>
                </v-flex> -->
                <v-flex lg12 md12 sm12>
                    <v-textarea outlined dense :disabled="currentRecharge.ID > 0" label="Ghi chú" v-model="currentRecharge.TradeContent" class="input-group--focused"></v-textarea>
                </v-flex>
                <v-layout class="d-flex flex-row">
                    <v-flex lg7 md7 sm7>
                        <v-btn block color="#0051a2" dark @click="saveData">
                            Nạp tiền
                        </v-btn>
                    </v-flex>
                    <v-flex lg5 md5 sm5 pr-8>
                        <v-btn block color="second" dark @click="clearData">
                            Hủy lệnh
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-layout>
        </v-card>
    </v-container>
    <div class="page-header-left pl-3 pt-5" v-if="!csRole">
        <h3>Lịch sử nạp tiền</h3>
    </div>
    <recharge-list></recharge-list>
</div>
</template>

<script>
import {
    mapState
} from "vuex";
import configs from "@/configs";
import {
    sendErrorNotice
} from '@/commons/utils';
import recharge_list from "./list.vue";
export default {
    components: {
        "recharge-list": recharge_list
    },
    data() {
        return {
            recharge_status: configs.RECHARGE_STATUS,
            recharge_status_list: configs.RECHARGE_STATUS_LIST,
            rechargeMethods: configs.RECHARGE_METHODS,
            editStatus: 1
        };
    },
    computed: {
        ...mapState({
            customers: state => state.customer.master.data,
            loading: state => state.rechargeHistory.loading,
            currentRecharge: state => state.rechargeHistory.selected,
        }),
        rechargeId() {
            return this.$route.params.Pid;
        },
        csRole() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.CustomerService;
        },
        roleCustomer() {
            return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Customer;
        },
        currentUser() {
            return this.$store.state.authentication.user;
        },
    },
    watch: {
        currentRecharge() {
            if (this.rechargeId > 0) {
                this.editStatus = this.currentRecharge.Status;
            } else {
                this.editStatus = this.recharge_status.Approved;
            }
        },
        rechargeId() {
            this.refreshData();
        },
        csRole() {
            this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleSaveButton: this.csRole});
        }
    },
    methods: {
        refreshData() {
            this.getCustomerList();
            if (this.rechargeId > 0) {
                this.$store.dispatch("rechargeHistory/getDetail", this.rechargeId);
            }
            else {
                this.clearData();
            }
        },
        clearData() {
            if (!this.rechargeId) {
                this.$store.commit("rechargeHistory/setDetail", {
                    data: {
                        ID: 0,
                        UID: this.roleCustomer ? this.$store.state.authentication.user.userid : 0,
                        Method: 4,
                        Username: '',
                        Amount: 0,
                        Status: this.recharge_status.Approved,
                        TradeContent: ''
                    }
                });
            }
        },
        saveData() {
            if (this.currentRecharge.Amount <= 0 || this.currentRecharge.UID === 0) {
                sendErrorNotice(`Hãy nhập số tiền và user muốn nạp`);
                return;
            }
            if (this.currentRecharge.ID > 0 && this.currentRecharge.Status === this.editStatus) {
                return;
            }
            this.currentRecharge.Status = this.editStatus;
            let customer = this.roleCustomer ? { Username: this.currentUser.username } : _.find(this.customers, {
                ID: this.currentRecharge.UID
            });
            if (customer) {
                this.currentRecharge.RechargeID = this.$store.state.authentication.user.userid;
                this.currentRecharge.Username = customer.Username;
                this.$store.dispatch("rechargeHistory/setDetail", {
                    data: this.currentRecharge,
                    id: this.currentRecharge.ID
                });
                if (!this.currentRecharge.ID || this.currentRecharge.ID === 0) {
                    this.$store.commit("rechargeHistory/setDetail", {
                        data: {
                            ID: 0,
                            UID: this.roleCustomer ? this.$store.state.authentication.user.userid : 0,
                            Method: 4,
                            Username: '',
                            Amount: 0,
                            Status: this.recharge_status.Approved,
                            TradeContent: ''
                        }
                    });
                }
            } else {
                sendErrorNotice('Không tìm thấy khách hàng.')
            }

        },
        getCustomerList() {
            if (this.roleCustomer) {
                return;
            }
            this.$store.dispatch("customer/getCustomerList", {
                is_master: 1,
                fields: ["ID", "Username"]
            });
        },
    },
        mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {
            invisibleSaveButton: true,
            invisibleExportButton: this.roleCustomer,
            invisibleCreateButton: true
        });
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.currentRecharge.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style>
</style>
